import { toolbarOptions } from "pages/Ecommerce/EcommerceOrders/CMSDetails"
import React, { useState } from "react"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

import { CardBody, Input } from "reactstrap"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"

let CompanyName = "Company Name"
let CompanyNumber = "Company Number"

const EditEmailContent = props => {
  console.log("EditEmailContent -> props", props)
  const [subject, setSubject] = useState(props.emailContent.subjectText)
  const [bodyText, setBodyText] = useState(props.emailContent.bodyText)
  const [ccEmails, setCcEmails] = useState(props.emailContent.ccEmails)

  const handleEditSubmission = async () => {
    try {
    await API_SERVICE.updateEmailContent({
      subjectText: subject,
      bodyText: bodyText,
      ccEmails: ccEmails.length > 0 ? ccEmails.split(",") : []
    })
      notification("success", "Email content updated successfully")
      props.setEdit(false)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  return (
    <CardBody
      style={{
        minHeight: "calc(100vh - 230px)",
      }}
      className="edit-email-content-container"
    >
      <div className="instruction-container">
        <p>
          <span className="short-heading">Instructions: </span>
          Personalize your email subject and body using the variables{" "}
          {CompanyName} and {CompanyNumber}.
        </p>
        <p className="short-heading">How to use:</p>
        <ul>
          <li>
            <strong className="li-heading">Subject: </strong>
            <span>
              Type your subject and insert variables as needed. Example:
              "Welcome to {CompanyName}!
            </span>
          </li>
          <li>
            <strong className="li-heading">Body: </strong>
            <span>
              Body: Write your message and use variables to include dynamic
              content. Example: "Hello {CompanyName}. Your Company number is{" "}
              {CompanyNumber}.
            </span>
          </li>
        </ul>
        <p>
          <span className="short-heading">Note: </span>
          Use variables exactly as shown. Preview your email to ensure
          everything looks correct.
        </p>
      </div>
      <h2>CC Email Address</h2>
      <Input
        value={ccEmails}
        onChange={event => setCcEmails(event.target.value)}
        placeholder="Enter CC Email Address..."
      />
      <h2>Email subject</h2>
      <Input
        value={subject}
        onChange={event => setSubject(event.target.value)}
        placeholder="Enter Subject..."
      />
      <h2>Email body</h2>
      <ReactQuill
        placeholder="Enter Email Body..."
        modules={{
          toolbar: toolbarOptions,
        }}
        style={{ backgroundColor: "white" }}
        theme="snow"
        value={bodyText}
        onChange={value => {
          setBodyText(value)
        }}
      />
      <div className="text-end d-flex justify-content-end align-items-center gap-3">
        <button
          className="btn theme-btn-outline save-user mr-2"
          onClick={() => props.setEdit(false)}
        >
          Cancel
        </button>
        <button
          type={"button"}
          onClick={handleEditSubmission}
          className="btn theme-btn save-user"
        >
          Save
        </button>
      </div>
    </CardBody>
  )
}

export default EditEmailContent
